module.exports = __webpack_public_path__ + "img/lange_crub_5.d20fc9d9.jpg";